import React, { forwardRef } from 'react'
import { pageError } from '@byted-vcloud/exp-lite-slardar'
import { SlardarEventType } from '~/constants'

interface CatchErrorProviderProps {
  children: JSX.Element
  errorRender?: React.ReactNode
}

interface CatchErrorProviderState {
  hasError: boolean
}

class CatchErrorProvider extends React.Component<
  CatchErrorProviderProps,
  CatchErrorProviderState
> {
  static getDerivedStateFromError() {
    return { hasError: true }
  }

  state = {
    hasError: false,
  }

  shouldComponentUpdate(
    nextProps: CatchErrorProviderProps,
    nextState: CatchErrorProviderState,
  ) {
    if (nextState.hasError) {
      return false
    }
    return true
  }

  componentDidCatch(error: Error) {
    pageError({
      error: {
        type: SlardarEventType.GlobalCatch,
        message: '全局错误捕获',
        stack: error?.stack,
      },
    })
  }

  render() {
    const { children, errorRender } = this.props
    const { hasError } = this.state
    if (hasError) {
      return errorRender || 'Error!'
    }

    return children
  }
}

interface WithCatchErrorProviderConfig {
  errorRender?: React.ReactNode
}

export const withCatchErrorProvider = (
  Component: React.ElementType,
  options?: WithCatchErrorProviderConfig,
) => {
  const WithRoot = forwardRef((props, ref) => {
    const { errorRender } = options || {}

    return (
      <CatchErrorProvider errorRender={errorRender}>
        <Component {...props} ref={ref} />
      </CatchErrorProvider>
    )
  })

  return WithRoot
}

export default CatchErrorProvider
